export const earliestDateLimit = 1136102400000 // Jan 1st 2006



// WEBPACK FOOTER //
// ./src/constants/value-constants.js